module.exports = __webpack_public_path__ + "static/media/work-yellow-signs.a9e84657.jpg";